import { useDeviceType } from "@dash/mq";
import { HeaderBar, Page } from "@dash/page";
import { QuerySkeleton } from "@dash/skeleton";
import { useParams } from "react-router-dom-v5-compat";

import { useClientManager } from "@megaron/react-clients";

import { OrderDetails } from "./OrderDetails";
import { OrderItems } from "./OrderItems";
import { OrderMenu } from "./OrderMenu";
import { OrderShippingSection } from "./OrderShippingSection";
import { OrderStatusTile } from "./OrderStatusTile";

export const OrderPage = () => {
  const { number } = useParams<{ number: string }>();

  const { isMobile } = useDeviceType();

  const orderQuery = useClientManager("crm").orderQuery().useQuery({ orderNumber: number! });

  const title = [orderQuery.data?.number, orderQuery.data?.sellToName].filter(Boolean).join(" - ");

  return (
    <>
      <QuerySkeleton query={orderQuery} height="58px" width="100%">
        {(order) => <HeaderBar header={title} actions={<OrderMenu draftId={order.draftId} />} />}
      </QuerySkeleton>

      <Page
        css={{
          display: "flex",
          marginBottom: "2rem",
          marginTop: "83px",
          padding: isMobile ? "0 1rem" : "0 2rem",
          flexDirection: "column",
          gap: "1rem",
        }}
      >
        <QuerySkeleton query={orderQuery} height="40px" width="100%">
          {(order) => <OrderStatusTile status={order.status} />}
        </QuerySkeleton>

        <QuerySkeleton query={orderQuery} height="160px" width="100%">
          {(order) => <OrderDetails order={order} />}
        </QuerySkeleton>

        <QuerySkeleton query={orderQuery} height="160px" width="100%">
          {(order) => <OrderItems orderItems={order.lines} />}
        </QuerySkeleton>

        <QuerySkeleton query={orderQuery} height="220px" width="100%">
          {(order) => (
            <OrderShippingSection
              source={{ source: "order", orderNumber: order.number }}
              itemNames={Object.fromEntries(order.lines.map((line) => [line.itemId, line.itemName ?? line.itemId]))}
            />
          )}
        </QuerySkeleton>
      </Page>
    </>
  );
};
